._AutomationButton_1put8_1 {
  padding-right: 0;
  padding-left: 0;
  font-weight: normal;
}

._ConfirmationModal_1put8_7 {
  font-weight: 600;
}